import { Controller } from "@hotwired/stimulus";

// Slice 6 WS-4 (T-S6-WS4-06 follow-up) — lightweight disclosure dropdown used by
// the "Change Video" control when re-trim is available. It only toggles a menu's
// visibility; the menu items keep their original ids/data attributes so existing
// jQuery handlers (change video / delete) stay bound and behave exactly as before.
export default class extends Controller {
  static targets = ["toggle", "menu"];

  connect() {
    this.onOutsideClick = this.onOutsideClick.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
    document.addEventListener("click", this.onOutsideClick);
    document.addEventListener("keydown", this.onKeydown);
  }

  disconnect() {
    document.removeEventListener("click", this.onOutsideClick);
    document.removeEventListener("keydown", this.onKeydown);
  }

  toggle(event) {
    event.preventDefault();
    event.stopPropagation();
    this.isOpen ? this.close() : this.open();
  }

  open() {
    this.menuTarget.hidden = false;
    if (this.hasToggleTarget) {
      this.toggleTarget.setAttribute("aria-expanded", "true");
    }
    this.element.classList.add("is-open");
  }

  close() {
    this.menuTarget.hidden = true;
    if (this.hasToggleTarget) {
      this.toggleTarget.setAttribute("aria-expanded", "false");
    }
    this.element.classList.remove("is-open");
  }

  get isOpen() {
    return !this.menuTarget.hidden;
  }

  onOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.close();
    }
  }

  onKeydown(event) {
    if (event.key === "Escape") {
      this.close();
    }
  }
}
